// import { useEffect, useState } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import {
//   Database,
//   Server,
//   Cpu,
//   BookOpenCheck,
//   Briefcase,
//   ShieldCheck,
//   Code2,
//   ChevronDown,
// } from "lucide-react";

// export default function Foxpro() {
//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });
//     window.scrollTo(0, 0);
//   }, []);

//   const [openFaq, setOpenFaq] = useState(null);

//   const curriculum = [
//     { title: "Introduction to FoxPro", icon: Code2 },
//     { title: "Data Handling & Tables", icon: Database },
//     { title: "Procedural Programming Concepts", icon: Cpu },
//     { title: "Forms & User Interface", icon: BookOpenCheck },
//     { title: "File & Database Management", icon: ShieldCheck },
//     { title: "Queries & Reports", icon: Server },
//     { title: "Relational Databases in FoxPro", icon: Database },
//     { title: "Mini Project (Business App)", icon: BookOpenCheck },
//   ];

//   const careers = [
//     {
//       role: "Database Programmer",
//       img: "https://cdn-icons-png.flaticon.com/512/4205/4205356.png",
//     },
//     {
//       role: "Business App Developer",
//       img: "https://cdn-icons-png.flaticon.com/512/3135/3135673.png",
//     },
//     {
//       role: "Legacy Software Maintainer",
//       img: "https://cdn-icons-png.flaticon.com/512/2920/2920244.png",
//     },
//     {
//       role: "MIS Executive",
//       img: "https://cdn-icons-png.flaticon.com/512/1055/1055644.png",
//     },
//     {
//       role: "System Analyst",
//       img: "https://cdn-icons-png.flaticon.com/512/2721/2721295.png",
//     },
//   ];

//   const faqs = [
//   {
//     question: "Is FoxPro still useful?",
//     answer:
//       "Yes, FoxPro is still used in some organizations for maintaining legacy applications and database systems.",
//   },
//   {
//     question: "Will I learn practical applications?",
//     answer:
//       "Definitely! You’ll build business-related projects like inventory and billing systems.",
//   },
//   {
//     question: "Do I need prior programming knowledge?",
//     answer:
//       "No, this course starts from basics and moves to intermediate concepts step by step.",
//   },
//   {
//     question: "What kind of projects will I work on?",
//     answer:
//       "You will work on business-oriented projects like payroll systems, billing software, and data management applications.",
//   },
//   {
//     question: "How long is the course?",
//     answer:
//       "The course duration is 3 months, with weekly assignments and a final capstone project.",
//   },
//   {
//     question: "Will I receive a certificate after completion?",
//     answer:
//       "Yes, upon successful completion, you’ll receive a course completion certificate.",
//   },
//   {
//     question: "Can I get job assistance after the course?",
//     answer:
//       "Yes, we provide career guidance, interview preparation, and resume-building support.",
//   },
//   {
//     question: "Is this course online or offline?",
//     answer:
//       "The course is available in both formats: online live sessions and classroom-based learning.",
//   },
//   {
//     question: "What tools or software do I need?",
//     answer:
//       "You’ll need Visual FoxPro installed on your system. We provide setup guidance at the beginning of the course.",
//   },
//   {
//     question: "Is there any support if I get stuck?",
//     answer:
//       "Yes, you’ll have access to doubt-solving sessions, discussion forums, and direct mentor support.",
//   },
// ];

//   return (
//     <div className="bg-gray-50 text-gray-800">
//       {/* 🌟 Hero Section with Background Image */}
// <section
//   className="relative bg-cover bg-center text-white py-32 px-6 overflow-hidden"
//   style={{
//     backgroundImage:
//       "url('https://www.udacity.com/_next/image?url=https%3A%2F%2Fvideo.udacity-data.com%2Ftopher%2F2024%2FOctober%2F67098831_ud109%2Fud109.jpg&w=3840&q=75')",
//   }}
// >
//   {/* Overlay for readability */}
//   <div className="absolute inset-0 bg-opacity-60"></div>

//   <div className="relative max-w-4xl mx-auto text-center" data-aos="fade-up">
//     <h1 className="text-6xl font-extrabold mb-6 leading-tight">
//       Master FoxPro Programming
//     </h1>
//     <p className="text-lg text-gray-200 mb-6">
//       Build strong foundations in database programming and business
//       application development using FoxPro. Learn by doing with
//       real-world projects.
//     </p>
//     <a
//       href="/contact"
//       className="inline-block bg-yellow-400 text-purple-900 px-10 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-yellow-300 transition"
//     >
//       Enroll Now 🚀
//     </a>
//   </div>
// </section>

//       {/* 📘 About Section */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
//           <div data-aos="fade-up">
//             <img
//               src="https://cdn-icons-png.flaticon.com/512/906/906324.png"
//               alt="Coding Illustration"
//               className="w-full max-w-md mx-auto animate-pop"
//             />
//           </div>
//           <div data-aos="fade-up" data-aos-delay="200">
//             <h2 className="text-4xl font-bold text-purple-700 mb-6">
//               Why Learn FoxPro?
//             </h2>
//             <p className="text-gray-600 text-lg mb-4">
//               FoxPro may be a legacy technology, but it powers many business
//               systems worldwide. Companies still need skilled developers to
//               maintain and enhance these systems.
//             </p>
//             <p className="text-gray-600 text-lg">
//               By mastering FoxPro, you’ll gain expertise in database handling,
//               procedural programming, and business application development —
//               highly valuable in maintaining enterprise solutions.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* 📚 Curriculum (Timeline Style) */}
//       <section className="py-20 px-6 bg-purple-50">
//         <div className="max-w-4xl mx-auto text-center">
//           <h2 className="text-4xl font-bold mb-12 text-purple-700">
//             Learning Path
//           </h2>
//           <div className="relative">
//             <div className="absolute left-1/2 transform -translate-x-1/2 h-full border-l-4 border-purple-300"></div>
//             <div className="space-y-12">
//               {curriculum.map((item, idx) => (
//                 <div
//                   key={idx}
//                   className={`relative flex items-center ${
//                     idx % 2 === 0 ? "justify-start" : "justify-end"
//                   }`}
//                   data-aos="fade-up"
//                   data-aos-delay={idx * 100}
//                 >
//                   <div className="bg-white border border-gray-200 shadow-lg rounded-2xl p-6 w-72 text-center hover:scale-105 transition animate-pop">
//                     <item.icon
//                       className="text-purple-600 mb-4 mx-auto"
//                       size={36}
//                     />
//                     <h6 className="font-semibold text-lg">{item.title}</h6>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* 💼 Careers */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-6xl mx-auto">
//           <h2 className="text-4xl font-bold text-center mb-12 text-purple-700">
//             Career Opportunities
//           </h2>
//           <div className="flex gap-6 overflow-x-auto pb-4">
//             {careers.map((career, idx) => (
//               <div
//                 key={idx}
//                 className="min-w-[220px] bg-purple-50 rounded-2xl shadow-md p-6 flex flex-col items-center hover:animate-jump transition"
//                 data-aos="zoom-in"
//                 data-aos-delay={idx * 100}
//               >
//                 <img
//                   src={career.img}
//                   alt={career.role}
//                   className="w-20 h-20 mb-4"
//                 />
//                 <h5 className="font-semibold text-purple-800 text-lg">
//                   {career.role}
//                 </h5>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ❓ FAQ */}
// <section className="bg-purple-50 py-16 px-6">
//   <div className="max-w-2xl mx-auto">
//     <h2 className="text-3xl font-bold text-center mb-8 text-purple-700">
//       FAQs
//     </h2>
//     <div className="space-y-3">
//       {faqs.map((faq, idx) => (
//         <div
//           key={idx}
//           className="border border-gray-200 rounded-lg shadow-sm bg-white overflow-hidden"
//           data-aos="fade-up"
//         >
//           <button
//             onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
//             className="flex justify-between items-center w-full p-4 text-left font-medium text-base"
//           >
//             {faq.question}
//             <ChevronDown
//               className={`transition-transform ${
//                 openFaq === idx ? "rotate-180" : ""
//               }`}
//             />
//           </button>
//           {openFaq === idx && (
//             <div className="p-4 pt-0 text-gray-600 text-sm animate-pop">
//               {faq.answer}
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   </div>
// </section>

//       {/* 🚀 Final CTA */}
//       <section className="relative py-24 px-6 bg-gradient-to-r from-purple-700 to-indigo-800 text-white text-center">
//         <div className="max-w-4xl mx-auto">
//           <h2 className="text-5xl font-extrabold mb-6 leading-tight animate-pop">
//             Start Your FoxPro Journey Today
//           </h2>
//           <p className="mb-8 text-lg opacity-90">
//             Learn, build, and grow with hands-on projects and expert mentorship.
//           </p>
//           <a
//             href="/contact"
//             className="inline-block bg-yellow-400 text-purple-900 px-10 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-yellow-300 hover:scale-105 transform transition"
//           >
//             Enroll Now 🚀
//           </a>
//         </div>
//       </section>

//       {/* ✨ Custom Animations */}
//       <style>{`
//         .animate-float {
//           animation: float 4s ease-in-out infinite;
//         }
//         @keyframes float {
//           0% { transform: translateY(0px); }
//           50% { transform: translateY(-15px); }
//           100% { transform: translateY(0px); }
//         }
//         .animate-jump {
//           animation: jump 0.6s ease-in-out;
//         }
//         @keyframes jump {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }
//         .animate-pop {
//           animation: pop 0.4s ease-in-out;
//         }
//         @keyframes pop {
//           0% { transform: scale(0.8); opacity: 0.5; }
//           100% { transform: scale(1); opacity: 1; }
//         }
//       `}</style>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Database,
  Server,
  Cpu,
  BookOpenCheck,
  ShieldCheck,
  Code2,
  ChevronDown,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function Foxpro() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  const [openFaq, setOpenFaq] = useState(null);

  const curriculum = [
    { title: "Introduction to FoxPro", icon: Code2 },
    { title: "Data Handling & Tables", icon: Database },
    { title: "Procedural Programming Concepts", icon: Cpu },
    { title: "Forms & User Interface", icon: BookOpenCheck },
    { title: "File & Database Management", icon: ShieldCheck },
    { title: "Queries & Reports", icon: Server },
    { title: "Relational Databases in FoxPro", icon: Database },
    { title: "Mini Project (Business App)", icon: BookOpenCheck },
  ];

  const careers = [
    {
      role: "Database Programmer",
      img: "https://cdn-icons-png.flaticon.com/512/4205/4205356.png",
    },
    {
      role: "Business App Developer",
      img: "https://cdn-icons-png.flaticon.com/512/3135/3135673.png",
    },
    {
      role: "Legacy Software Maintainer",
      img: "https://cdn-icons-png.flaticon.com/512/2920/2920244.png",
    },
    {
      role: "MIS Executive",
      img: "https://cdn-icons-png.flaticon.com/512/1055/1055644.png",
    },
    {
      role: "System Analyst",
      img: "https://cdn-icons-png.flaticon.com/512/2721/2721295.png",
    },
  ];

  const faqs = [
    {
      question: "Is FoxPro still useful?",
      answer:
        "Yes, FoxPro is still used in some organizations for maintaining legacy applications and database systems.",
    },
    {
      question: "Will I learn practical applications?",
      answer:
        "Definitely! You’ll build business-related projects like inventory and billing systems.",
    },
    {
      question: "Do I need prior programming knowledge?",
      answer:
        "No, this course starts from basics and moves to intermediate concepts step by step.",
    },
    {
      question: "What kind of projects will I work on?",
      answer:
        "You will work on business-oriented projects like payroll systems, billing software, and data management applications.",
    },
    {
      question: "How long is the course?",
      answer:
        "The course duration is 3 months, with weekly assignments and a final capstone project.",
    },
    {
      question: "Will I receive a certificate after completion?",
      answer:
        "Yes, upon successful completion, you’ll receive a course completion certificate.",
    },
    {
      question: "Can I get job assistance after the course?",
      answer:
        "Yes, we provide career guidance, interview preparation, and resume-building support.",
    },
    {
      question: "Is this course online or offline?",
      answer:
        "The course is available in both formats: online live sessions and classroom-based learning.",
    },
    {
      question: "What tools or software do I need?",
      answer:
        "You’ll need Visual FoxPro installed on your system. We provide setup guidance at the beginning of the course.",
    },
    {
      question: "Is there any support if I get stuck?",
      answer:
        "Yes, you’ll have access to doubt-solving sessions, discussion forums, and direct mentor support.",
    },
  ];

  return (
    <div className="bg-gray-50 text-gray-800 overflow-hidden">
      {/* 🌟 Hero Section */}
      <section
        className="relative bg-cover bg-center text-white py-32 px-6 overflow-hidden"
        style={{
          backgroundImage:
            "url('../assets/imageww.webp')",
        }}
      >
        {/* <div className="absolute inset-0 bg-black bg-opacity-60"></div> */}

        <div
          className="relative max-w-4xl mx-auto text-center"
          data-aos="fade-up"
        >
          <h1 className="text-5xl font-extrabold mb-6 leading-tight animate-bounce">
            Master FoxPro Programming
          </h1>
          <p className="text-lg text-gray-200 mb-6">
            Build strong foundations in database programming and business
            application development using FoxPro. Learn by doing with real-world
            projects.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-yellow-400 text-purple-900 px-6 py-2 rounded-lg font-semibold text-base shadow-lg hover:bg-yellow-300 transition"
          >
            Enroll Now 🚀
          </Link>
        </div>
      </section>

      {/* 📘 About Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-up">
            <img
              src="../assets/906324.png"
              alt="Coding Illustration"
              className="w-full max-w-md mx-auto animate-pop"
            />
          </div>
          <div data-aos="fade-up" data-aos-delay="200">
            <h2 className="text-4xl font-bold text-purple-700 mb-6">
              Why Learn FoxPro?
            </h2>
            <p className="text-gray-600 text-lg mb-4 text-justify">
              FoxPro may be a legacy technology, but it powers many business
              systems worldwide. Companies still need skilled developers to
              maintain and enhance these systems.
            </p>
            <p className="text-gray-600 text-lg text-justify">
              By mastering FoxPro, you’ll gain expertise in database handling,
              procedural programming, and business application development —
              highly valuable in maintaining enterprise solutions.
            </p>
          </div>
        </div>
      </section>

      {/* 📚 Curriculum (Animated Timeline Style) */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-12 text-purple-700">
            Learning Path
          </h2>
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full border-l-4 border-purple-200"></div>
            <div className="space-y-12">
              {curriculum.map((item, idx) => {
                const animations = [
                  "animate-bounce",
                  "animate-pulse",
                  "animate-shake",
                  "animate-spin-slow",
                  "animate-dance",
                ];
                const randomAnim =
                  animations[Math.floor(Math.random() * animations.length)];
                const aosEffect = idx % 2 === 0 ? "fade-left" : "fade-right";

                // 🎨 gradient colors for variety
                const gradients = [
                  "bg-gradient-to-r from-pink-400 to-pink-600",
                  "bg-gradient-to-r from-blue-400 to-blue-600",
                  "bg-gradient-to-r from-green-400 to-green-600",
                  "bg-gradient-to-r from-purple-400 to-purple-600",
                  "bg-gradient-to-r from-orange-400 to-orange-600",
                  "bg-gradient-to-r from-indigo-400 to-indigo-600",
                  "bg-gradient-to-r from-teal-400 to-teal-600",
                  "bg-gradient-to-r from-red-400 to-red-600",
                ];
                const gradient = gradients[idx % gradients.length];

                return (
                  <div
                    key={idx}
                    className={`relative flex items-center ${
                      idx % 2 === 0 ? "justify-start" : "justify-end"
                    }`}
                    data-aos={aosEffect}
                    data-aos-delay={idx * 150}
                  >
                    <div
                      className={`${gradient} text-white shadow-lg rounded-2xl p-6 w-72 text-center hover:scale-110 transition ${randomAnim}`}
                    >
                      <item.icon className="mb-4 mx-auto" size={40} />
                      <h6 className="font-semibold text-lg">{item.title}</h6>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* 💼 Careers */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 text-purple-700">
            Career Opportunities
          </h2>

          {/* Scrolling container */}
          <div className="relative overflow-hidden">
            <div className="flex gap-6 animate-scroll">
              {[...careers, ...careers].map(
                (
                  career,
                  idx // duplicate for smooth loop
                ) => (
                  <div
                    key={idx}
                    className="min-w-[220px] bg-purple-50 rounded-2xl shadow-md p-6 flex flex-col items-center hover:animate-dance transition"
                    data-aos="zoom-in"
                    data-aos-delay={(idx % careers.length) * 100}
                  >
                    <img
                      src={career.img}
                      alt={career.role}
                      className="w-20 h-20 mb-4"
                    />
                    <h5 className="font-semibold text-purple-800 text-lg">
                      {career.role}
                    </h5>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ❓ FAQ */}
      <section className="bg-purple-50 py-16 px-6">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8 text-purple-700">
            FAQs
          </h2>
          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm bg-white overflow-hidden"
                data-aos="fade-up"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="flex justify-between items-center w-full p-4 text-left font-medium text-base"
                >
                  {faq.question}
                  <ChevronDown
                    className={`transition-transform ${
                      openFaq === idx ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {openFaq === idx && (
                  <div className="p-4 pt-0 text-gray-600 text-sm animate-pop">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 🚀 Final CTA */}
      <section className="relative py-24 px-6 bg-gradient-to-r from-purple-700 to-indigo-800 text-white text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl font-extrabold mb-6 leading-tight animate-pop">
            Start Your FoxPro Journey Today
          </h2>
          <p className="mb-8 text-lg opacity-90">
            Learn, build, and grow with hands-on projects and expert mentorship.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-yellow-400 text-purple-900 px-6 py-2 rounded-lg font-semibold text-base shadow-lg hover:bg-yellow-300 transition"
          >
            Enroll Now 🚀
          </Link>
        </div>
      </section>

      {/* ✨ Custom Animations */}
      <style>{`
        .animate-shake {
          animation: shake 0.8s ease-in-out infinite;
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          50% { transform: translateX(5px); }
          75% { transform: translateX(-5px); }
        }

        .animate-spin-slow {
          animation: spin 6s linear infinite;
        }

        .animate-dance {
          animation: dance 1.2s infinite ease-in-out;
        }
        @keyframes dance {
          0%, 100% { transform: rotate(0deg) scale(1); }
          25% { transform: rotate(-5deg) scale(1.05); }
          50% { transform: rotate(5deg) scale(0.95); }
          75% { transform: rotate(-5deg) scale(1.05); }
        }

        .animate-pop {
          animation: pop 0.4s ease-in-out;
        }
        @keyframes pop {
          0% { transform: scale(0.8); opacity: 0.5; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
